<template>
  <div class="page flex-col">
    <div class="flex-col">
      <div class="group_4 flex-row">
        <div class="box_2 flex-col justify-between">
          <div class="text-wrapper_2">
              <span class="paragraph_1">
                2011年——2016年
                <br />
              </span>
            <span class="paragraph_2">
                管理咨询顾问
                <br />
              </span>
            <span class="paragraph_3">
                2022年11月，管理顾问公司成立。聚焦政府、企事业单位、高校等，提供战略咨询、市场营销、传播推广、企业文化等战略决策及策略实施支持服务。
                <br />
              </span>
          </div>
          <div class="text-wrapper_3">
              <span class="paragraph_4">
                2020年——2024年
                <br />
              </span>
            <span class="paragraph_5">
                全维度校园管家
                <br />
              </span>
            <span class="text_11">
                服务领域聚焦校园场景服务围绕文化校园、便捷校园、智慧校园、美丽校园、科创校园进行多元校园服务场景服务。
              </span>
          </div>
        </div>
        <div class="box_3 flex-col">
          <div class="group_5 flex-col">
            <div class="box_4 flex-col"></div>
            <div class="box_5 flex-col"></div>
            <div class="box_6 flex-col"></div>
            <div class="box_7 flex-col"></div>
          </div>
        </div>
        <div class="text-wrapper_4">
            <span class="paragraph_6">
              2016年——2020年
              <br />
            </span>
          <span class="paragraph_7">
              校园商业运营
              <br />
            </span>
          <span class="paragraph_8">
              2016年12月，商业运营公司成立。通过集成化服务整合，进行服务模式创新，为重庆大学、重庆师范大学、重庆机电职业技术学院等数一所高校师生提供更加便捷、智慧、多元的生活服务。
              <br />
            </span>
        </div>
      </div>
      <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="./assets/img/43f4b912ad252967734670c6318d26ae.webp"
      />
      <div class="text-wrapper_5">
          <span class="paragraph_9">
            2006年——2010年
            <br />
          </span>
        <span class="paragraph_10">
            文化产业服务
            <br />
          </span>
        <span class="paragraph_11">
            2006年6月，文化传媒公司成立。以文化传媒业务为主体，服务校园、政府、企业事业单位等机构提供文化展示、文化塑造、文化活动、校园生活服务等服务。
            <br />
          </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
